import { PermissionResource } from '@entities/tenant/permission';

import { requirePermission } from '../../../require-permission';

// TODO: confirm Resource for the debtors domain — mapped to `Clients` (клієнти/боржники).
export const debtorsLoader = requirePermission(PermissionResource.TenantClients);
